module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-nav"
  }, [_c('el-menu', {
    staticClass: "header-nav__menu",
    attrs: {
      "theme": "dark",
      "default-active": "1",
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    staticClass: "header-nav__item",
    attrs: {
      "index": "2"
    },
    on: {
      "click": function($event) {
        _vm.changeUrl({
          name: 'Connections'
        })
      }
    }
  }, [_c('i', {
    staticClass: "header-nav__icon fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Połączenia\n    ")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "header-nav__item",
    attrs: {
      "index": "3"
    },
    on: {
      "click": function($event) {
        _vm.changeUrl({
          name: 'WidgetsList'
        })
      }
    }
  }, [_c('i', {
    staticClass: "header-nav__icon fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Widgety\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a03a63","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/HeaderContainer/HeaderNav/index.vue
// module id = 740
// module chunks = 3